import { render, staticRenderFns } from "./mes-bom-create.vue?vue&type=template&id=6ed112a2&scoped=true&"
import script from "./mes-bom-create.vue?vue&type=script&lang=js&"
export * from "./mes-bom-create.vue?vue&type=script&lang=js&"
import style0 from "./mes-bom-create.vue?vue&type=style&index=0&id=6ed112a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed112a2",
  null
  
)

export default component.exports